import React from 'react'
import {Box, Container} from '@mui/material'
import {Outlet, useLocation} from 'react-router-dom'
import {TIMER_FIT_MEDIA} from './theme/feltTheme'
import ResponsiveAppBar from './ResponsiveAppBar'

export default function AppLayout() {
  const isTimerRoute = useLocation().pathname === '/'
  return <Box sx={{width: '100%', minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary', ...(isTimerRoute && {[TIMER_FIT_MEDIA]: {height: '100svh', display: 'flex', flexDirection: 'column'}})}}>
    <ResponsiveAppBar/>
    <Container component="main" id="application-content" maxWidth={isTimerRoute ? false : 'xl'} sx={{pt: isTimerRoute ? 1 : {xs: 3, sm: 5}, pb: isTimerRoute ? 'calc(8px + var(--timer-footer-space, 0px))' : {xs: 3, sm: 5}, flex: isTimerRoute ? 1 : undefined, minHeight: 0}}><Outlet/></Container>
  </Box>
}
